import styled from "styled-components";

type Props = {
  justifyContent?: string;
};

export const Container = styled.div<Props>`
  display: flex;
  max-width: 1280px;
  margin-right: auto;
  margin-left: auto;
  width: 100%;
`;
